import React from "react";
import { InView } from "react-intersection-observer";

import CardText from "./card/CardText";
import CardToggle from "./card/CardToggle";
import CardVideo from "./card/CardVideo";
import CardLink from "./card/CardLink";
import CardTextEmpty from "./card/CardTextEmpty";
import TextLong from "./TextLong";
import TextLongAfter from "./TextLongAfter";
import TextImage from "./TextImage";
import TextImageEnd from "./TextImage";
import TextTitle from "./TextTitle";
import CompareSlider from "./CompareSlider";
import ImageCaption from "./ImageCaption";
import Audio from "./Audio";
import TextToggle from "./TextToggle";
import MultipleImages from "./MultipleImages";
import TextVideo from "./TextVideo";
import TextVideoControls from "./TextVideoControls";
import TextYoutube from "./TextYoutube";
import TextIframe from "./TextIframe";
import Share from "./Share";


// import "./Card.css";

export default function PhoneCard({
  slidesContent,
  callbackFromParent,
}) {
  const SLIDES = slidesContent;

  // const slidesKeys = Object.keys(SLIDES);
  // const lastSlideToShow = slidesKeys.length + parseInt(slidesKeys[0]);

  const outlineStyle = {
    fontSize: 5,
    color: "white",
    position: "absolute",
    zIndex: 30,
  };
 
  const slideStyle = {
    height: "auto",
    width: "100vw",
    //outline: "#4CAF50 solid 10px",
  };

  const cardWrapperStyle = {
    minHeight: "100vh",
    height: "auto",
    width: "100vw",
  };

  const emptyCardStyle = {
    width: "0vw",
    position: "relative",
  };

  const cardStyle = {
    backgroundColor: "black",
    borderRadius: '10px 10px 10px 10px',
    margin: `15px 15px 15px 10vw`,
    padding: '2px 10px 10px 15px',
    opacity: 0.95,
    zIndex: 90,
    position: "relative",
  };

  

  return (
    <div style={outlineStyle} id={"outline-card"}>
      {Object.entries(SLIDES).map(([key, value]) => {
        const index = parseInt(key);
        return (
          <>
            <InView
              key={`scroller-slide-${value.index}`}
              initialInView={false}
              threshold={0.5}
              onChange={(inView, ref, entry) => {
                if (inView) {
                  console.warn("switching to", value.index);
                }
                inView && callbackFromParent(value.index);
              }}
            >
              {({ ref, inView, entry }) => (
                <div
                  key={index}
                  style={slideStyle}
                >
                  <div
                    id={"track-div-" + (index + 1).toString()}
                    ref={ref}
                    style={{
                      width: "100%",
                      height: "1%",
                    }}
                  />
                  {slidesContent[index].textImage ? (
                  <TextImage
                    src={slidesContent[index].textImage}
                    isMobile={true}
                  />) : null }
                  {slidesContent[index].textLong ? (
                  <TextLong
                    textLong={slidesContent[index].textLong}
                    isMobile={true}
                  />) : null }
                  {slidesContent[index].textIframe ? (
                  <TextIframe
                    src={slidesContent[index].textIframe}
                    isMobile={true}
                  />) : null }
                     {slidesContent[index].textTitle ? (
                  <TextTitle
                    textTitle={slidesContent[index].textTitle}
                    isMobile={true}
                  />) : null }
                  {slidesContent[index].audio ? (
                  <Audio
                    src={slidesContent[index].audio}
                    isMobile={true}
                  />) : null }
                  {slidesContent[index].textToggleTitle ? (
                  <TextToggle
                  textToggleTitle={slidesContent[index].textToggleTitle}
                  textToggleContent={slidesContent[index].textToggleContent}
                  isMobile={true}
                  />) : null }
                    {slidesContent[index].multipleImages ? (
                  <MultipleImages
                    multipleImages={slidesContent[index].multipleImages}
                  />) : null }
                   {slidesContent[index].compareSlider ? (
                  <CompareSlider
                    compareSlider={slidesContent[index].compareSlider}
                    isMobile={true}
                  />) : null }
                  {slidesContent[index].textVideo ? (
                  <TextVideo
                    textVideo={slidesContent[index].textVideo}
                    isMobile={true}
                  />) : null }
                   {slidesContent[index].textVideoControls ? (
                  <TextVideoControls
                    textVideoControls={slidesContent[index].textVideoControls}
                    isMobile={true}
                  />) : null }
                  {slidesContent[index].imageCaption ? (
                  <ImageCaption
                    imageCaption={slidesContent[index].imageCaption}
                    isMobile={true}
                  />) : null }
                  {slidesContent[index].share ? (
                  <Share
                    src={slidesContent[index].share}
                    isMobile={true}
                  />) : null }
                  {slidesContent[index].textLongAfter ? (
                  <TextLongAfter
                  textLongAfter={slidesContent[index].textLongAfter}
                  isMobile={true}
                  />) : null }
                   {slidesContent[index].textYoutube? (
                  <TextYoutube
                    src={slidesContent[index].textYoutube}
                    isMobile={true}
                  />) : null }
                  {slidesContent[index].textImageEnd ? (
                  <TextImageEnd
                    src={slidesContent[index].textImageEnd}
                    isMobile={true}
                  />) : null }
                    {slidesContent[index].emptyCard ? (
                     <div
                     style={cardWrapperStyle}
                     id={"card-wrapper-" + (index + 1).toString()}
                      >
                       <div
                      style={emptyCardStyle}
                      id={"card-container-" + (index + 1).toString()}
                      >
                           <CardTextEmpty 
                      text={slidesContent[index].emptyCard}
                      isMobile={false} 
                      />
                          </div>
                          </div>
                    ):null}
                  {slidesContent[index].contentCard ? (
                    <div
                       style={cardWrapperStyle}
                       id={"card-wrapper-" + (index + 1).toString()}
                    >                    <div
                      style={cardStyle}
                      id={"card-container-" + (index + 1).toString()}
                    >
                      <h3>
                        <font size="5">
                          {" "}
                          {slidesContent[index]
                            ? slidesContent[index].info
                            : "error: no slide number"}
                        </font>
                      </h3>
                      <CardText 
                        text={slidesContent[index].contentCard} 
                        isMobile={true}/>
                      <CardToggle
                        toggleTitle={slidesContent[index].toggleTitle}
                        toggleContent={slidesContent[index].toggleContent}
                      />
                      <CardLink src={slidesContent[index].inSlideLink} />
                      <CardVideo
                        src={slidesContent[index].inSlideVideoPlayer}
                      />
                    </div>
                    </div>
                  ) : null}
                </div>
              )}
            </InView>
          </>
        );
      })}
    </div>
  );
}
